import React, { useState, useRef } from 'react'
import styled, { theme } from '@nobia/zeus-components/lib/styled'
import PropTypes from 'prop-types'

const StyledFilterRow = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  ${props => props.theme.media.min.sm`
    justify-content: ${theme('filter.row.align')};
  `}
`

const StyledFilterColumn = styled.div`
  flex-direction: column;
  margin: ${theme('filter.column.margin')};
  color: ${theme('filter.column.color')};
  ${props => props.theme.media.min.sm`
    margin: ${theme('filter.column.marginDesktop')};
  `}
`
const StyledFilterHeader = styled.div`
  text-align: ${theme('filter.header.textAlign')};
`

const StyledFilterButton = styled.div`
  border: ${theme('filter.button.border')};
  border-radius: ${theme('filter.button.radius')};
  font-size: ${theme('filter.button.fontSize')};
  padding: ${theme('filter.button.padding')};
  color: ${theme('colors.text')};
  font-weight: ${theme('filter.button.fontWeight')};
  text-transform: ${theme('filter.button.textTransform')};
  letter-spacing: ${theme('filter.button.letterSpacing')};
  margin-bottom: 10px;
  display: inline-block;
  cursor: pointer;
  line-height: 22px;
  transition: all 0.2s ease-in;
  :hover {
    background-color: ${theme('filter.button.hover.background')};
    opacity: ${theme('filter.button.hover.opacity')};
  }
`
const StyledFilterType = styled.div`
  font-size: ${theme('filter.type.fontSize')};
  text-transform: ${theme('filter.type.textTransform')};
  color: ${theme('colors.text')};
  line-height: 25px;
  letter-spacing: ${theme('filter.type.letterSpacing')};
  margin-bottom: ${theme('filter.type.marginBottom')};
`

const StyledFilterItem = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.44px;
  cursor: pointer;
`

const StyledFilterItemLabel = styled.span`
  padding-right: 15px;
  position: relative;
  color: ${props => (props.selected ? theme('colors.text') : null)};
  font-weight: ${theme('filter.label.fontWeight')};
  margin-bottom: ${theme('filter.label.marginBottom')};
  display: ${theme('filter.label.display')};
  letter-spacing: ${theme('filter.label.letterSpacing')};
`

const StyledFilterItemIcon = styled.span`
  position: absolute;
  right: -2px;
  top: ${theme('filter.icon.position')};
  transform: rotate(45deg);
  font-size: 18px;
`

const StyledFilterIcon = styled.span`
  opacity: ${props => (props.show ? 1 : 0)};
  transition: opacity 0.5s;
  position: absolute !important;
  left: 7px;
  top: ${theme('filter.icon.position')};
`

const StyledFilterIconWrapper = styled.span`
  position: relative;
`

const StyledFilterCollapse = styled.div`
  max-height: 0;
  overflow: hidden;
  width: 100%;
  opacity: ${props => (props.show ? 1 : 0)};
  transition: ${props =>
    props.show
      ? 'max-height 1s, opacity 0.5s 0.5s linear'
      : 'max-height 0.5s 0.5s, opacity 0.5s linear'};
`

const GalleryFilter = ({
  selectedFilters,
  filters,
  filterLabel,
  onClickFilter,
}) => {
  const [showFilters, setShowFilters] = useState(false)
  const filterRef = useRef(null)
  const filterWrapperRef = useRef(null)

  const toggleFilter = () => {
    setShowFilters(!showFilters)
    filterWrapperRef.current.style.maxHeight = showFilters
      ? null
      : `${filterRef.current.scrollHeight}px`
  }

  return (
    <>
      <StyledFilterHeader>
        <StyledFilterButton onClick={toggleFilter}>
          {filterLabel}
          <StyledFilterIconWrapper>
            <StyledFilterIcon show={!showFilters}>+</StyledFilterIcon>
            <StyledFilterIcon show={showFilters}>-</StyledFilterIcon>
          </StyledFilterIconWrapper>
        </StyledFilterButton>
      </StyledFilterHeader>
      <StyledFilterCollapse ref={filterWrapperRef} show={showFilters}>
        <StyledFilterRow ref={filterRef}>
          {filters.map(filter => (
            <StyledFilterColumn key={filter.name}>
              <StyledFilterType>{filter.name}</StyledFilterType>
              {filter.categories.expandedValue &&
                filter.categories.expandedValue.length > 0 &&
                filter.categories.expandedValue.map(filterItem => (
                  <StyledFilterItem
                    key={filterItem.contentLink.id}
                    onClick={() => onClickFilter(filterItem.contentLink.id)}
                  >
                    <StyledFilterItemLabel
                      selected={selectedFilters.includes(
                        filterItem.contentLink.id
                      )}
                    >
                      {filterItem.name.value}
                      {selectedFilters.includes(filterItem.contentLink.id) && (
                        <StyledFilterItemIcon>+</StyledFilterItemIcon>
                      )}
                    </StyledFilterItemLabel>
                  </StyledFilterItem>
                ))}
            </StyledFilterColumn>
          ))}
        </StyledFilterRow>
      </StyledFilterCollapse>
    </>
  )
}

GalleryFilter.propTypes = {
  selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filterLabel: PropTypes.string.isRequired,
  onClickFilter: PropTypes.func.isRequired,
}

export default GalleryFilter
